import { oddsType } from "@fresh8/types/src/index";
/**
 * Odds Formatter
 * Takes odds and formats them into local display preference
 * @param   {Array}   odds            - Odds to be displayed
 * @param   {String}  displayOptions  - Option for the display type
 * @return  {String}  A rendered odds template
 */
export function formatOdds(odds: number[], format: oddsType): string {
  if (odds[0] === 0 && odds[1] === 0) {
    return "-";
  } else if (odds[0] < 0 || odds[1] < 0) {
    return "SP";
  } else {
    switch (format) {
      case "decimalOdds": {
        const decimal = odds[0] / odds[1] + 1;
        return String(decimal.toFixed(2));
      }
      case "europeanDecimalOdds": {
        const decimalNumber = odds[0] / odds[1] + 1;
        return decimalNumber.toFixed(2).replace(".", ",");
      }
      case "americanOdds": {
        if (odds[0] > odds[1]) {
          const over = (odds[0] / odds[1]) * 100;
          return `+${String(Math.round(over))}`;
        } else if (odds[0] < odds[1]) {
          const under = -100 / (odds[0] / odds[1]);
          return String(Math.round(under));
        } else {
          return "+100";
        }
      }
      case "impliedProbability": {
        const percentage = (1 / (odds[0] / odds[1] + 1)) * 100;
        return `${Number(percentage.toFixed(1))}%`;
      }
      default: {
        return odds[0] + "/" + odds[1];
      }
    }
  }
}
